import { useLayoutEffect, useRef, useState } from 'react'
import { Link, Stack, Text } from '@fluentui/react'

type MessageTextProps = {
  message: string | null
}

const CLAMPED_STYLE = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical' as const,
  overflow: 'hidden',
}

const MessageText = ({ message }: MessageTextProps) => {
  const textRef = useRef<HTMLDivElement>(null)
  const [isExpanded, setIsExpanded] = useState(false)
  const [isTruncated, setIsTruncated] = useState(false)

  useLayoutEffect(() => {
    const element = textRef.current
    if (element && !isExpanded) setIsTruncated(element.scrollHeight > element.clientHeight + 1)
  }, [message, isExpanded])

  if (message === null) {
    return <Text styles={{ root: { color: '#605e5c', fontStyle: 'italic' } }}>Message text unavailable</Text>
  }

  return (
    <Stack tokens={{ childrenGap: 4 }} horizontalAlign="start">
      <div
        ref={textRef}
        style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#323130', ...(isExpanded ? {} : CLAMPED_STYLE) }}
      >
        {message}
      </div>
      {(isTruncated || isExpanded) && (
        <Link onClick={() => setIsExpanded((expanded) => !expanded)} aria-expanded={isExpanded}>
          {isExpanded ? 'Show less' : 'Show more'}
        </Link>
      )}
    </Stack>
  )
}

export default MessageText
